import React, { ForwardedRef, forwardRef } from 'react';
import { ActionItemButton } from '@components/button/action-item-button';

import { isTouchInsideTarget } from './utils/is-touch-inside-target';
import type { ButtonAction } from './submenu-icon.type';

export const SubmenuIconButton = forwardRef(
  ({ name, disabled, action, active, close, icon, dataTestId }: ButtonAction, ref: ForwardedRef<HTMLButtonElement>) => {
    const executeAction = () => {
      if (close) close();
      if (action) action();
    };
    const handleClick = (e?: React.MouseEvent<HTMLElement>) => {
      if (e) e.stopPropagation();
      executeAction();
    };
    const handleTouchEnd = (e: React.TouchEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (isTouchInsideTarget(e)) executeAction();
    };
    return (
      <ActionItemButton
        ref={ref}
        key={`option-menu-${name}`}
        active={active ?? false}
        onClick={handleClick}
        onTouchEnd={handleTouchEnd}
        text={name}
        disabled={disabled}
        icon={icon}
        dataTestId={dataTestId}
      />
    );
  }
);
